// Fields of study related to development, programming, and technology
export const fieldsOfStudy = [
  // Computer Science & Software Engineering
  'Computer Science',
  'Software Engineering',
  'Computer Engineering',
  'Information Technology',
  'Information Systems',
  'Information Science',
  
  // Web Development
  'Web Development',
  'Frontend Development',
  'Backend Development',
  'Full Stack Development',
  'Web Design',
  
  // Mobile Development
  'Mobile App Development',
  'iOS Development',
  'Android Development',
  'Mobile Computing',
  
  // Data Science & Analytics
  'Data Science',
  'Data Analytics',
  'Data Engineering',
  'Big Data',
  'Business Intelligence',
  'Statistics',
  'Applied Mathematics',
  
  // Artificial Intelligence & Machine Learning
  'Artificial Intelligence',
  'Machine Learning',
  'Deep Learning',
  'Neural Networks',
  'Natural Language Processing',
  'Computer Vision',
  'Robotics',
  
  // Cybersecurity
  'Cybersecurity',
  'Information Security',
  'Network Security',
  'Ethical Hacking',
  'Digital Forensics',
  
  // Cloud & DevOps
  'Cloud Computing',
  'DevOps',
  'Systems Administration',
  'Network Administration',
  
  // Game Development
  'Game Development',
  'Game Design',
  'Game Programming',
  'Interactive Media',
  
  // Blockchain & Cryptocurrency
  'Blockchain Technology',
  'Cryptocurrency',
  'Distributed Systems',
  
  // Database Management
  'Database Administration',
  'Database Management',
  'Data Management',
  
  // UI/UX Design
  'User Interface Design',
  'User Experience Design',
  'Human-Computer Interaction',
  'Interaction Design',
  'Graphic Design',
  'Digital Design',
  
  // Software Architecture
  'Software Architecture',
  'System Design',
  'Enterprise Architecture',
  
  // Quality Assurance & Testing
  'Software Testing',
  'Quality Assurance',
  'Test Engineering',
  
  // Project Management (Tech)
  'IT Project Management',
  'Agile Project Management',
  'Product Management',
  
  // Networking
  'Computer Networks',
  'Network Engineering',
  'Telecommunications',
  
  // Embedded Systems & IoT
  'Embedded Systems',
  'Internet of Things (IoT)',
  'Microcontrollers',
  
  // Other Related Fields
  'Computer Graphics',
  'Operating Systems',
  'Algorithm Design',
  'Software Development',
  'Programming',
  'Coding',
  'Digital Marketing',
  'E-Commerce',
  'Business Technology',
  'Computational Science',
  'Theoretical Computer Science',
  'Other (Please specify)',
];

